module.exports = __webpack_public_path__ + "img/reglas.09a29f42.jpg";